module.exports = "/_next/static/images/autoProduto-18c5606309ae96459a30d9f8fddcd32c.svg";